// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".exc-textarea[data-v-539c1b7a]{position:relative}.exc-textarea__label[data-v-539c1b7a]{margin:0 0 .3125rem}.exc-textarea__info[data-v-539c1b7a]{position:absolute;top:100%;left:0;height:.9375rem;display:flex}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
